import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule, MatIconModule } from '@angular/material';
import { PipesModule } from '@fuse/pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { VideoInfoModalComponent } from './video-info-modal.component';
import { VideoInfoModalService } from './video-info-modal.service';

@NgModule({
  declarations: [VideoInfoModalComponent],
  imports: [MatDialogModule, MatIconModule, CommonModule, TranslateModule, PipesModule],
  providers: [VideoInfoModalService],
  exports: [],
  entryComponents: [VideoInfoModalComponent]
})
export class VideoInfoModalModule {}
